import {LoadingPage as ShellLoadingPage} from 'shells/loading-page/loading-page';

import {PageWrapper} from '../../layout/page-wrapper';

export function LoadingPage() {
    return (
        <PageWrapper>
            <ShellLoadingPage />
        </PageWrapper>
    );
}
